import { render, staticRenderFns } from "./SsoTokenLogin.vue?vue&type=template&id=38f7522c&scoped=true"
import script from "./SsoTokenLogin.vue?vue&type=script&lang=js"
export * from "./SsoTokenLogin.vue?vue&type=script&lang=js"
import style0 from "./SsoTokenLogin.vue?vue&type=style&index=0&id=38f7522c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f7522c",
  null
  
)

export default component.exports